// 自定义指令总注册处
import type { App, Directive } from 'vue'
import action from './permission/action'
import tabPermissionDirective from './permission/tab'
import aos from './aos'

const directivesList: Record<string, Directive> = {
  action,
  'tab-permission': tabPermissionDirective,
  aos
}

const directives = {
  install(app: App) {
    Object.keys(directivesList).forEach((key) => {
      app.directive(key, directivesList[key])
    })
  }
}

export default directives
